import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useMatches } from 'react-router';

import type { RouteHandle } from '~/routing/types';

import { setDocumentTitle } from '~/utils/dom';

function isMessageDescriptor(value: unknown): value is RouteHandle['title'] {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    typeof value.id === 'string'
  );
}

function isRouteHandle(value: unknown): value is RouteHandle {
  return (
    typeof value === 'object' &&
    value !== null &&
    'title' in value &&
    isMessageDescriptor(value.title)
  );
}

export const useBrowserTitle = () => {
  const matches = useMatches();
  const intl = useIntl();

  useEffect(() => {
    const handle = [...matches]
      .reverse()
      .map((match) => match.handle)
      .find(isRouteHandle);

    if (handle) {
      setDocumentTitle(intl.formatMessage(handle.title));
    }

    return () => setDocumentTitle();
  }, [matches, intl]);
};
